import { render, staticRenderFns } from "./AssetFields.vue?vue&type=template&id=70879a06&"
import script from "./AssetFields.vue?vue&type=script&lang=ts&"
export * from "./AssetFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports